/* This example requires Tailwind CSS v2.0+ */
const navigation = {
  discover: [
    { name: 'Marketplace', href: '/marketplace' },
    { name: 'Resources', href: '/blog' },
    { name: 'Careers', href: '/jobs' },
  ],
  learnmore: [
    { name: 'How It Works', href: '/how-it-works' },
    { name: 'Partners', href: '/pilotprogram' },
    { name: 'Vendors', href: '/vendors' },
  ],
  company: [
    { name: 'Team', href: '/team' },
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Service', href: '/terms-of-service' },
  ],
}

const Footer = () => {
  return (
    <footer aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="font-primary text-blue-footer py-12 px-4 xl:px-0 xl:py-16">
        <div className="xl:flex xl:flex-row">
          <div className="flex flex-col items-center xl:items-start xl:col-span-1">
            <a href="/">
            <img
              className="w-footer-logo-width h-footer-logo-height"
              src="/images/logo.png"
              alt="Chamber Convoy"
            />
            </a>
            <div className="hidden xl:block mt-auto">
              <p className="text-body-1">&copy; 2022 Chamber Convoy, Inc.</p>
            </div>
          </div>

          <div className="ml-auto mt-10 xl:mt-0 md:col-span-2">
            <div className="lg:grid lg:grid-cols-3 lg:grid-flow-col-dense xl:gap-12">
              <div className="flex flex-col items-center xl:items-start space-y-4">
                <h3 className="font-secondary text-headline-5 font-semibold">Discover</h3>
                  {navigation.discover.map((item) => (
                    <a key={item.name} href={item.href} className="text-body-1 border-b-2 border-transparent 2xl:text-body-md hover:border-blue-500">
                      {item.name}
                    </a>
                  ))}
              </div>

              <div className="mt-8 lg:mt-0">
                <div className="flex flex-col items-center xl:items-start space-y-4">
                  <h3 className="font-secondary text-headline-5 font-semibold">Learn More</h3>
                    {navigation.learnmore.map((item) => (
                      <a key={item.name} href={item.href} className="text-body-1 border-b-2 border-transparent 2xl:text-body-md hover:border-blue-500">
                        {item.name}
                      </a>
                    ))}
                </div>
              </div>

              <div className="mt-8 lg:mt-0">
                <div className="flex flex-col items-center xl:items-start space-y-4">
                  <h3 className="font-secondary text-headline-5 font-semibold">Company</h3>
                    {navigation.company.map((item) => (
                      <a key={item.name} href={item.href} className="text-body-1 border-b-2 border-transparent 2xl:text-body-md hover:border-blue-500">
                        {item.name}
                      </a>
                    ))}
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="xl:hidden flex flex-col items-center mt-8">
            <span className="text-body-1">&copy; 2022 Chamber Convoy, Inc.</span>
        </div>
        
        <div className="text-grey-footer text-body-2 py-6 mt-6 footer-border" style={{
          // fontSize: '12px',
          // color: '#4E5361',
          lineHeight: '20px',
          // paddingTop: '24px',
          // borderTop: '1px solid #BFBFBF',
          // marginTop: '24px',
        }}>
          <p>Offers may be revised or removed at any time and without notice. All trademarks are the property of their respective owners. The presence of a third-party trademark does not indicate a relationship between The Convoy and with the third-party, or that the third-party endorses The Convoy or its services.</p>
        </div>
        
      </div>
    </footer>
  )
}

export default Footer;
